import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.1, delay, ease }}
    >
      {children}
    </M>
  );
};

const line = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.2, delay: d, ease } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={`${l}-${i}`} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={line} custom={delay + i * 0.12}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
